import moment from 'moment';
import { Week } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function getFirstActiveWeekQuery(this: UiQueries): Week {
  const today = moment();
  // All weeks in past, so technically there is no active week
  // but return that last week anyways
  const lastWeek = this.uiState.weeks[this.uiState.weeks.length - 1];
  if (lastWeek.weekId.endOfWeek.isSameOrBefore(today)) {
    return lastWeek;
  }

  // there should always be a match
  const firstActiveWeek = this.uiState.weeks.filter((week) =>
    today.isBefore(week.weekId.endOfWeek)
  )[0];

  return firstActiveWeek;
}
